import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

/** 📊GTM: SPAのページ遷移をdataLayerへ通知（GTM側は「履歴の変更」or カスタムイベントpage_view_spaで計測可能） */
declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}
function GtmPageView() {
  const location = useLocation();
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view_spa",
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location]);
  return null;
}

/** ページ遷移で最上部へ戻す（SPAはデフォルトで前ページのスクロール位置が残るため、
 *  フッター等のリンクを押すと下部のまま表示される不具合の修正）。
 *  #アンカー付きリンクのときはその要素へスクロール。 */
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

/** Router の内側（クライアント/サーバー共通）。SSRでは StaticRouter で、
 *  クライアントでは BrowserRouter で包んで使う。 */
export function AppInner() {
  return (
    <>
      <ScrollToTop />
      <GtmPageView />
      <AppRoutes />
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppInner />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
